export const getDistance = (point1, point2) => {
  const radLat1 = (point1.lat * Math.PI) / 180.0;
  const radLat2 = (point2.lat * Math.PI) / 180.0;
  const a = radLat1 - radLat2;
  const b = (point1.lng * Math.PI) / 180.0 - (point2.lng * Math.PI) / 180.0;
  const c = Math.sin(a / 2) ** 2
  const d = Math.cos(radLat1)
  const e = Math.cos(radLat2)
  const f = Math.sin(b / 2) ** 2
  let s = 2 * Math.asin(Math.sqrt(c + d * e * f));
  s = Math.round(s * 6378.137 * 10000) / 10;
  return s
}
